import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { hotelsSlice } from "@common/redux/slices/entities.slice";
import { IHotel } from "@common/redux/types/places";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EntityCard } from "@kursk/components/ui/EntityCard/EntityCard";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function HotelsGrid() {
  const { items, total, offset } = useSelectSlice(hotelsSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IHotel>
      entityType="hotels"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IHotel, index) => <EntityCard key={item._id} type={getCardType(index)}
        entityType="hotels"
        entity={item}/>}
    />
  );
}
